module.exports = __webpack_public_path__ + "img/img-header-mobile.648eabd.webp";